import Vue from 'vue'
import App from './App.vue'
import VueScrollReveal from 'vue-scroll-reveal'
import VueScrollTo from 'vue-scrollto'

Vue.config.productionTip = false
Vue.use(VueScrollReveal, {
  class: 'animate-active',
  duration: 600,
  scale: 1,
  distance: '0px',
  delay: 400
})
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

new Vue({
  render: h => h(App)
}).$mount('#app')
